import React, { Component } from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { isProdLike } from './configurations/env_config';

if(isProdLike){
    Bugsnag.start({
        apiKey: 'f89d2371ec650616616d3ae68dd406bf',
        plugins: [new BugsnagPluginReact()],
    })
}

/**
 * A tab opened before a deploy requests chunk filenames that no longer exist.
 * That is a stale-asset problem, not a code fault, so reloading fixes it.
 *
 * The guard is a count within a rolling window rather than a permanent flag: a
 * long-lived tab that crosses several deploys still recovers each time, while a
 * genuinely broken chunk stops after MAX_RELOADS instead of looping.
 */
const CHUNK_RELOAD_KEY = 'chunk_reload';
const MAX_RELOADS = 2;
const RELOAD_WINDOW_MS = 60 * 60 * 1000;

// Returns true and records the attempt, or false when the budget is spent.
const claimReloadAttempt = () => {
    const now = Date.now();
    let state;
    try {
        state = JSON.parse(window.sessionStorage.getItem(CHUNK_RELOAD_KEY));
    } catch (e) {
        state = null;
    }
    if (!state || now - state.firstAt > RELOAD_WINDOW_MS) state = { firstAt: now, count: 0 };
    if (state.count >= MAX_RELOADS) return false;
    try {
        window.sessionStorage.setItem(CHUNK_RELOAD_KEY, JSON.stringify({ firstAt: state.firstAt, count: state.count + 1 }));
    } catch (e) {
        // sessionStorage unavailable (private mode) — no way to bound retries, so don't reload
        return false;
    }
    return true;
};

const isChunkLoadError = (error) => {
    if (!error) return false;
    if (error.name === 'ChunkLoadError') return true;
    return /Loading chunk \S+ failed|Loading CSS chunk \S+ failed/i.test(error.message || '');
};

export default class ComponentErrorBoundary extends Component {
    constructor(props){
        super(props);
        this.state = {
            caughtError: false
        }
    }
    static getDerivedStateFromError(error) {
        if (isChunkLoadError(error) && claimReloadAttempt()) {
            window.location.reload();
            return { caughtError: false };
        }
        return { caughtError: true };
      }

      componentDidCatch(error, errorInfo) {
        if(isProdLike && !isChunkLoadError(error)){
            Bugsnag.notify(error);
        }
      }
    render() {
        if(this.state.caughtError && isProdLike) return(
            <div className="text_subtitle article_container" style={{textAlign: 'center', marginTop: 110}}>
                Oops!!! Something went wrong. We apologize for the reported error and are actively resolving it.
            </div>
        )
        return this.props.children;
  }
}
